import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconUnderlineStyle0 = gravityIconIndividualCss;

const GravityIconUnderline = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'a2a570d7e0565d31a1890026af57ee0c6c7d48f0', color: this.color, size: this.size }, h("svg", { key: 'fe8ae1b8865bb2751deaa5a367040de5ff3c3e5c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '5de689baa35735d0ecea092e83fc9c060732a5f1', d: "M6 4.5v5.93c0 3.22 1.94 5.07 4.99 5.07 3.05 0 5-1.85 5-5.07V4.5a.5.5 0 0 0-.5-.5H15a.5.5 0 0 0-.49.5v6.27A3.34 3.34 0 0 1 11 14.15a3.37 3.37 0 0 1-3.5-3.38V4.5A.5.5 0 0 0 7 4h-.5a.5.5 0 0 0-.5.5Zm.5 12.97a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-9Z", fill: "currentColor" }))));
    }
};
GravityIconUnderline.style = GravityIconUnderlineStyle0;

export { GravityIconUnderline as gravity_icon_underline };

//# sourceMappingURL=gravity-icon-underline.entry.js.map